import axios from 'axios'
import { toast } from 'react-toastify'

const urlServer = process.env.REACT_APP_URL_SERVIDOR

export const api = axios.create({
    baseURL: urlServer,
})

export function getImagem(imagem){
    try {
        return `${urlServer}?servico=getImagem&imagem=${imagem}` 
    } catch (error) {
        return ""
    }
}

export async function getDadosAPI(rota = '', filtro = {}, lista = true){
    try {
        const res = await api.post('?servico=' + rota, filtro)
        if(res.data.situacao === "ok"){
            return (lista ? res.data.arrayObj : res.data.obj)
        } else {
            res.data.erro.forEach(e => {
                toast.error(e.msg)
            })
        }
        return (lista ? [] : {})
    } catch (error) {
        toast.error(error.message)

        return (lista ? [] : {})
    }
}

export async function setDadosAPI(rota = '', dados, retornaErros = false){
    try {
        const res = await api.post('?servico=' + rota, dados)
        if(res.data.situacao === "ok"){
            return true
        } else {
            if(!retornaErros){
                res.data.erro.forEach(e => {
                    toast.error(e.msg)
                })
                return false
            } else {
                return res.data.erro.map(e => e.msg)
            }
        }
    } catch (error) {
        if(!retornaErros){
            toast.error(error.message)

            return false
        } else {
            return [{ msg: error.message }]
        }
    }
}

export async function requisicaoXHR(url, body, method = 'POST'){
    return new Promise((resolve, reject) => {
        try {
            var xhr = new XMLHttpRequest()
            xhr.open(method, `${urlServer}?servico=${url}`, true)
            xhr.onload = function () {
                if(this.status >= 200 && this.status < 300){
                    const res = JSON.parse(xhr.response)
                    if(res.situacao === "ok"){
                        resolve(res)
                    } else {
                        res.erro.forEach(e => {
                            toast.error(e.msg)
                        })
                        resolve(false)
                    }
                } else {
                    toast.error(xhr.statusText)
                    resolve(false)
                }
            }
            xhr.onerror = function () {
                toast.error('Falha ao realizar requisição')
                resolve(false)
            }

            xhr.send(body);
        } catch (error) {
            toast.error('Falha ao realizar requisição')
            resolve(false)
        }
    })
}

export async function download(arquivo = '', dados = {}, nomeArquivo = '', tipoArquivo = 'text/plain'){
    try {
      const res = await api.get('?servico=downloadArquivo&arquivo=' + arquivo, { params: dados, responseType: 'blob' })

      const blob = new Blob([res.data], { type: tipoArquivo })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', (nomeArquivo !== '' ? nomeArquivo : 'download'))
      document.body.appendChild(link)

      link.click()
      link.remove()
    } catch (error) {
      toast.error(error.message)
    }
  }